import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Toggle } from 'cat-ecommerce-alloy';

const PreferenceToggle = ({
  isAvailabilityToggled = false,
  setIsAvailabilityToggled,
  id = ''
}) => {
  const [t] = useTranslation();
  const showAvailabilityBySource = useSelector(
    state =>
      !!state.shoppingPreferences?.shoppingPreferencesData
        ?.showSourcingDetailToggle
  );
  const isStoreAvailabilityEnabled = useSelector(
    state => !!state.dealer?.isStoreAvailabilityEnabled
  );
  const label = showAvailabilityBySource
    ? t('AVAIL_STANDARD_AVAILAIBILITY_DATES')
    : t('AVAIL_STANDARD_AVAILABILITY_SOURCE');
  return (
    isStoreAvailabilityEnabled && (
      <Toggle
        id={`showAvailabilityAndSourcingDetailsToggle${id}`}
        data-testid={`showAvailabilityAndSourcingDetailsToggle${id}`}
        className="u-color--DarkGray px-2 d-print-none"
        label={label}
        labelClassName="text-sans-serif text-transform-none u-fs--16 u-fs-lg--14"
        checked={isAvailabilityToggled}
        setChecked={setIsAvailabilityToggled}
        placement="start"
      />
    )
  );
};

PreferenceToggle.propTypes = {
  isAvailabilityToggled: PropTypes.bool,
  setIsAvailabilityToggled: PropTypes.func,
  id: PropTypes.string
};

export default PreferenceToggle;
